import {
    Box,
    Button,
    Chip,
    ListItem,
    ListItemIcon,
    ListItemText,
    Tooltip,
} from "@mui/material";
import React, { Dispatch, SetStateAction, useEffect, useState } from "react";
import CircularProgressWithLabel from "../circularProgressWithLabel";
import DeleteIcon from "@mui/icons-material/Delete";
import * as attachmentService from "services/attachment-service";
import { fileTypeStyle } from "utilities/colorHelper";
import { AiOutlineLoading } from "react-icons/ai";
import { IconContext } from "react-icons";
import { height } from "@mui/system";
import { t } from "i18next";
import { useTranslation } from "react-i18next";

type FileUploadType = {
    id: string;
    dbId?: string;
    file: File;
    progress: number;
    extension?: string;
    type?: string;
};

interface Props {
    index: number;
    fileUpload: FileUploadType;
    icon: React.ElementType;
    total: number;
    updateState: Dispatch<SetStateAction<FileUploadType[]>>;
    setFilesUploaded: Dispatch<SetStateAction<boolean>>;
    onClick?: Dispatch<FileUploadType>;
    downloadable?: boolean;
    disable?: boolean;
    completionHash?: string,
    getFilesChanged?: Function,
    detailPage?: boolean;
    type?: string;
    showIcon?: boolean;
    getFiles?: (files: FileUploadType[]) => void;
    disableDelete?: boolean;
}

const InfoFileRow = (props: Props) => {
    const {
        index,
        fileUpload,
        icon,
        total,
        updateState,
        setFilesUploaded,
        onClick,
        downloadable,
        completionHash,
        disable,
        detailPage,
        type,
        showIcon: showIconProp,
        getFiles,
        disableDelete = false
    } = props;
    // console.log("Index: " + index)
    const [showIcon, setShowIcon] = useState(showIconProp ? showIconProp : false);
    const { t } = useTranslation();

    useEffect(() => {
        if (fileUpload.progress === 100) {
            setTimeout(() => setShowIcon(true), 1000);
        }
    }, [fileUpload.progress]);

    // TODO: update delete for request detail part
    async function handleDeleteFile(attachmentId: string, id: string): Promise<void> {
        if (fileUpload.progress == 100) {
            await attachmentService.deleteAttachmentAsync(attachmentId, completionHash ? completionHash : '').then(() => {
                if (props.getFilesChanged) {
                    props.getFilesChanged(attachmentId, false);
                }
                updateState((prevFileUploads) => {
                    const newFiles = prevFileUploads.filter((file) => file.dbId !== attachmentId)
                    getFiles && getFiles(newFiles);
                    return newFiles;
                }
                );
            });
        } else {
            updateState((prevFileUploads) => {
                const newFiles = prevFileUploads.filter((file) => file.id !== id)
                getFiles && getFiles(newFiles);
                return newFiles;
            }
            );
        }

        if (total - 1 <= 0) {
            console.log('row: set FALSE')
            setFilesUploaded(false);
        }
    }

    function handleOnClick(): void {
        if (onClick != undefined) {
            onClick(fileUpload);
        }
    }

    return (
        <Box
            sx={{
                padding: "1rem",
                display: "flex",
                justifyContent: "space-between",
                borderBottom:
                    index < total - 1 ? "1px solid rgba(189, 189, 189,0.3)" : "",
                "&:hover": {
                    backgroundColor: "rgba(189, 189, 189,0.1)",
                },
            }}
        >
            <Box
                sx={{
                    flex: 1,
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    display: "flex",
                    flexDirection: "row",
                    // justifyItems: "center",
                    // alignItems: "center",
                    // maxWidth: "100%",
                    // width: '100%',
                    "&:hover": {
                        color: downloadable ? "#2196f3" : "inherit",
                        textDecoration: downloadable ? "underline" : "inherit",
                        cursor: downloadable ? 'pointer' : 'inherit'
                    }
                }}
                onClick={() => handleOnClick()}
            >
                {fileUpload.progress > 0 && fileUpload.progress <= 100 && !showIcon ? (
                    <ListItem
                        sx={{
                            width: "32px",
                            margin: "0 1rem",
                            padding: "0",
                            flex: '0 0 auto'
                        }}
                    >
                        <ListItemIcon>
                            <CircularProgressWithLabel value={fileUpload.progress} />
                        </ListItemIcon>
                    </ListItem>
                ) : (
                    showIcon &&
                    <Box sx={{ flex: '0 0 auto', display: 'flex' }}>
                        <Box component={icon} />
                    </Box>
                )}

                <Box sx={{ alignSelf: 'center', width: '100%', overflow: 'hidden', marginRight:'10px'}}>
                    <Tooltip title={<h3>{fileUpload.file.name}</h3>} arrow>
                        <Box sx={{width: '100%', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                            {/* {fileUpload.file.name.length > 30
                                ? fileUpload.file.name.substring(0, 29) +
                                ` ... ${fileUpload.file.name.substring(fileUpload.file.name.length - 15, fileUpload.file.name.length)}`
                                : fileUpload.file.name} */}
                                {fileUpload.file.name}
                        </Box>
                    </Tooltip>
                    {/*fileUpload.file.size < 1048576 ? (
                        <Box>{Math.round(fileUpload.file.size / 1024).toFixed(2)} KB</Box>
                    ) : (
                        <Box>
                            {Math.round(fileUpload.file.size / 1048576).toFixed(2)} MB
                        </Box>
                    )*/}
                </Box>
            </Box>
            <Box sx={{
                display: 'flex',
                // width: '25%',
            }}>
                <DeleteIcon
                    onClick={async (e) => {
                        e.stopPropagation();
                        await handleDeleteFile(fileUpload.dbId as string, fileUpload.id)
                    }}
                    sx={{
                        width: "30px !important",
                        height: "30px !important",
                        color: "#0064B4",
                        p: "5px",
                        borderRadius: "10px",
                        position: "end",
                        marginRight: '0.50rem',
                        "&:hover": { backgroundColor: "red", color: "white" },
                        visibility: ((disable && !disableDelete) || fileUpload.type == 'Vertrouwelijkheidsovereenkomst') ? 'hidden' : '',
                        display: ((disable && !disableDelete) || fileUpload.type == 'Vertrouwelijkheidsovereenkomst') ? 'none' : ''
                    }}
                />
                {(detailPage && fileUpload.type) &&
                    <Box sx={{
                        height: '100%',
                        // paddingRight: '0.5rem',
                        padding: '0',
                        display: 'grid',
                        alignItems: 'center',
                        width: '100%',
                    }}>
                        <Chip sx={{ backgroundColor: fileTypeStyle(fileUpload.type), color: 'white' }} label={t(fileUpload.type)} />
                    </Box>
                }
            </Box>
        </Box>
    );
};
export default InfoFileRow;
